import {useQuery} from 'react-query';
import {getSponsorDetail} from '.';

const useGetSponsorDetail = (guid: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['sponsorDetail',guid],
    queryFn: () => getSponsorDetail(guid),
    enabled: !!guid,
  });
  return {sponsorDetail: data, isLoading};
};

export default useGetSponsorDetail;
